function getNextIndex(moveAmount, current, total) {
  const maxIndex = total - 1;
  if (current === null) {
    return moveAmount > 0 ? 0 : maxIndex;
  }
  const nextIndex = moveAmount + current;
  if (nextIndex > maxIndex) {
    return 0;
  }
  if (nextIndex < 0) {
    return maxIndex;
  }
  return nextIndex;
}
const getNextEnabledIndex = (direction, currentIndex, itemsCount, items) => {
  const startIndex = currentIndex === null ? direction > 0 ? 0 : itemsCount - 1 : currentIndex;
  let nextIndex = startIndex;
  for (let i = 0; i < itemsCount; i++) {
    nextIndex = (nextIndex + direction + itemsCount) % itemsCount;
    const item = items[nextIndex];
    if (!item.props.disabled) {
      return nextIndex;
    }
  }
  return startIndex;
};
export {
  getNextEnabledIndex,
  getNextIndex
};
